// Mutable store shared between React DOM layer and Three.js render loop
export const scrollStore = {
  progress: 0,
  igniting: false,
};
